import React from "react"
import Layout from "antd/es/layout"
import { Seo } from "components/seo/seo"
import { createGlobalStyle } from "styled-components"
import { MasterHeader } from "./MasterHeader"

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: Open Sans,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji !important;
  }
`

type Props = {
  title: string
  description: string
  image?: string
  bg?: boolean
}

export const MainLayout: React.FC<Props> = props => {
  return (
    <>
      <GlobalStyle />
      <Layout>
        <MasterHeader bg={props.bg} />
        <Seo {...props} />
        {props.children}
      </Layout>
    </>
  )
}
